import { render } from "./HeroAuthDriverDashboard.vue?vue&type=template&id=38110b41&scoped=true"
import script from "./HeroAuthDriverDashboard.vue?vue&type=script&lang=js"
export * from "./HeroAuthDriverDashboard.vue?vue&type=script&lang=js"

import "./HeroAuthDriverDashboard.vue?vue&type=style&index=0&id=38110b41&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38110b41"]])

export default __exports__